import { Action } from 'core/generic';
import { Modal } from 'core/modal';
import { Paginate } from 'core/paginate';
import React from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { EmptyList, Loading } from 'utils/GenericCompoents';
import { Categorie, deleteCategorie } from './';

interface ComponentState {
  showModal: boolean;
  isRemovingCategorie: boolean;
  selectedCategory?: string;
  page: number;
  itensPerPage: number;
  isLoading: boolean;
}

interface ListCategoriesActions {
  list: Categorie[];
  isLoading: boolean;
  dispatch: (action: Action) => void;
}

class ListCategoryComponent extends React.Component<
  ListCategoriesActions,
  ComponentState
> {
  state: ComponentState = {
    isLoading: false,
    showModal: false,
    isRemovingCategorie: false,
    selectedCategory: undefined,
    page: 0,
    itensPerPage: 10,
  };

  onPaginateChange = (selectedItem: { selected: number }) => {
    this.setState({ page: selectedItem.selected });
  };

  handleCloseModal = () => {
    if (!this.state.isRemovingCategorie) {
      this.setState({
        showModal: false,
        selectedCategory: undefined,
      });
    }
  };

  onDeleteCategoria = (event: React.MouseEvent<HTMLElement>) => {
    const selectedCategory = event.currentTarget.dataset.value;

    this.setState({
      showModal: true,
      selectedCategory,
    });
  };

  onConfirmDeleteCategoria = async () => {
    this.setState({ isRemovingCategorie: true });

    try {
      const { selectedCategory } = this.state;
      if (!selectedCategory) {
        throw new Error();
      }

      await deleteCategorie(selectedCategory, this.props.dispatch);
    } catch (e) {
      toast.error('Ocorreu um erro ao remover a categoria, tente novamente');
    }

    this.setState({ isRemovingCategorie: false });
    this.handleCloseModal();
  };

  renderActions() {
    if (this.state.isRemovingCategorie) {
      return <div className='ui button red loading'>Apagar</div>;
    }

    return (
      <React.Fragment>
        <div className='ui button' onClick={this.handleCloseModal}>
          Cancelar
        </div>
        <div className='ui button red' onClick={this.onConfirmDeleteCategoria}>
          Apagar
        </div>
      </React.Fragment>
    );
  }

  renderModal() {
    const { showModal, selectedCategory } = this.state;
    if (!showModal || !selectedCategory) {
      return null;
    }

    return (
      <Modal
        header='Tem certeza que deseja remover esta categoria?'
        content={selectedCategory}
        isOpen={this.state.showModal}
        actions={this.renderActions()}
        handleClose={this.handleCloseModal}
      />
    );
  }

  renderCategories() {
    const { list } = this.props;
    if (list.length === 0) {
      return null;
    }

    const inicio = this.state.page * this.state.itensPerPage;
    const fim = inicio + this.state.itensPerPage;

    const categoriesContent = list.slice(inicio, fim).map(({ description }) => (
      <div className='column' key={description}>
        <Categoria className='ui action input'>
          <input className='Read Only' value={description} readOnly={true} />
          <button data-value={description} onClick={this.onDeleteCategoria}>
            <i className='trash icon' />
          </button>
        </Categoria>
      </div>
    ));

    return (
      <div className='ui segment'>
        {this.renderModal()}
        <div className='ui header'>
          <h3>Categorias de artista</h3>
        </div>
        <div className='ui one column grid'>{categoriesContent}</div>
        <Paginate
          page={this.state.page}
          onPaginateChange={this.onPaginateChange}
          total={this.props.list.length}
          itensPerPage={this.state.itensPerPage}
        />
      </div>
    );
  }

  renderEmptyCategories() {
    if (this.state.isLoading || this.props.isLoading) {
      return <Loading />;
    }

    return <EmptyList message='Lista de categorias vazia.' />;
  }

  render() {
    const { list } = this.props;

    if (list.length === 0) {
      return this.renderEmptyCategories();
    } else {
      return this.renderCategories();
    }
  }
}

export const ListCategories = ListCategoryComponent;

const Categoria = styled.div`
  width: 100%;
  margin: 0.5em 0;
`;
